import Job from "@/components/Job";
import SemesterDetail from "@/components/jiuye/SemesterDetail";
export default [{
    path: "/weekly.html",
    name: "Job",
    component: Job,
    meta: {
        title: '就业详情_51Testing软件测试培训网'
    }
}, {
    path: "/jiuye_sh.html",
    name: "Job2",
    component: Job,
}, {
    path: "/jiuye_bj.html",
    name: "Job3",
    component: Job,
}, {
    path: "/jiuye_sz.html",
    name: "Job4",
    component: Job,
}, {
    path: "/jiuye_cd.html",
    name: "Job5",
    component: Job,
}, {
    path: "/jiuye_nj.html",
    name: "Job6",
    component: Job,
}, {
    path: "/jiuye_xa.html",
    name: "Job7",
    component: Job,
}, {
    path: "/jiuye_wh.html",
    name: "Job8",
    component: Job,
},{
    path: "/jiuye_hz.html",
    name: "Job9",
    component: Job,
}, {
    path: "/jiuye_cq.html",
    name: "Job10",
    component: Job,
}, {
    path: "/jiuye_gz.html",
    name: "Job11",
    component: Job,
}, {
    path: "/jobDetail/:cityName",
    name: "JobDetail",
    component: SemesterDetail
}, ]


// WEBPACK FOOTER //
// ./src/router/jiuye.js